import React, { useCallback, useMemo, useRef, useState } from "react";

import { Button } from "@costar-ui/components";
import { IconHelpOutline } from "@costar-ui/icons/md/IconHelpOutline";

import { useStrictI18N } from "../../../../hooks";

import HelpPopover from "./help-popover";
import HelpTooltip from "./help-tooltip";
import { HelpButtonProps } from "./types";

import { useNavState } from "$common";

const HelpFeedbackButton = ({ hideRequestTraining }: HelpButtonProps) => {
    const {
        nav: { tabSelection },
        subnav: { subNavTabSelection },
    } = useNavState();

    // If more "ifs" needed, please consider making a mapper function
    const productMode: string = useMemo((): string => {
        if (subNavTabSelection === "NEW_LEASE_COMPS") {
            return "LEASE COMPS";
        } else if (subNavTabSelection === "LEASE_COMPS_HML") {
            return "HM LAND REGISTRY";
        }
        return tabSelection;
    }, [tabSelection, subNavTabSelection]);

    const resources = useStrictI18N();

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const buttonRef = useRef(null);

    const onHoverStart = useCallback(() => {
        if (!popoverOpen) {
            setTooltipOpen(true);
        }
    }, [popoverOpen, setTooltipOpen]);

    const onHoverEnd = useCallback(() => {
        if (tooltipOpen) {
            setTooltipOpen(false);
        }
    }, [tooltipOpen, setTooltipOpen]);

    const onClick = useCallback(() => {
        setTooltipOpen(false);
        setPopoverOpen(true);
    }, [setTooltipOpen, setPopoverOpen]);

    return (
        <div>
            <Button
                variant="secondary"
                size="fit-0-std"
                noBorder
                hoverMode="none"
                onPress={onClick}
                onHoverStart={onHoverStart}
                onHoverEnd={onHoverEnd}
                ref={buttonRef}
                testId="help-button"
            >
                <IconHelpOutline className="text-action-neutral" size="1.5em" />
            </Button>
            <HelpTooltip
                resources={resources}
                tooltipOpen={tooltipOpen}
                productMode={productMode}
                buttonRef={buttonRef}
            />

            <HelpPopover
                resources={resources}
                popoverOpen={popoverOpen}
                setPopoverOpen={setPopoverOpen}
                buttonRef={buttonRef}
                productMode={productMode}
                hideRequestTraining={hideRequestTraining}
            />
        </div>
    );
};

export default React.memo(HelpFeedbackButton);
